import * as amplitude from '@amplitude/analytics-browser';

import { useJobContext } from 'hb-react/frontoffice/apps/JobsV2/contexts/JobContext';
import Reactions from 'hb-react/frontoffice/components/Reactions';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import toggleLike from 'hb-react/shared/components/DesignSystem/Reactions/utils/toggleLike';
import useNavigatorShare from 'hb-react/shared/hooks/useNavigatorShare';
import { isCommentsModuleAvailable } from 'hb-react/shared/utils/features/comments';

const Comments = ({ urls }) => {
  const { id, likes, title } = useJobContext();

  const { currentUser, currentNetwork } = useDefaultAppContexts();
  const showReactions = isCommentsModuleAvailable(
    currentUser,
    !currentNetwork?.network_configuration?.business_opportunities
      ?.comments_enabled,
  );

  const sharedResourceUrl = `${window.location.origin}${urls.pathRoot}/${id}`;

  const { handleShare, shareUrl } = useNavigatorShare({
    data: {
      text: title,
      url: sharedResourceUrl,
    },
    onShare: () => {
      amplitude.track('Jobs|DiscussionShared');
    },
  });

  if (!showReactions) {
    return null;
  }

  return (
    <Reactions
      displayCommentsByDefault
      id={id}
      key={id}
      initialLikes={likes}
      onTogglePostLike={toggleLike}
      type="BusinessOpportunities::Request"
      railsType="BusinessOpportunities::Request"
      handleShareButton={handleShare}
      shareUrl={shareUrl}
    />
  );
};

export default Comments;
